import React from 'react'
import IconWrapper, { IconProps } from './IconWrapper'

export const AwarenessIcon = (props: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
        >
            <path
                d="M4 9.66667C3.999 8.4077 4.2891 7.16554 4.84761 6.03723C5.40613 4.90893 6.21794 3.92503 7.21965 3.1624C8.22135 2.39976 9.38581 1.87905 10.6221 1.64093C11.8583 1.40281 13.1329 1.45374 14.3462 1.78974C15.5595 2.12573 16.6787 2.73769 17.6164 3.57781C18.554 4.41794 19.2847 5.46347 19.7515 6.63274C20.2182 7.80201 20.4082 9.06335 20.3068 10.3182C20.2053 11.5731 19.8151 12.7875 19.1667 13.8667C18.5034 14.7511 17.7177 15.5367 16.8333 16.2C15.7994 17.1739 15.0013 18.371 14.5 19.7C14.138 20.3842 13.6291 20.9798 13.0099 21.4443C12.3907 21.9087 11.6765 22.2305 10.9183 22.3866C10.1602 22.5427 9.37691 22.5292 8.62459 22.3471C7.87227 22.165 7.16952 21.8188 6.56667 21.3333"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.66666 9.66667C8.65966 9.08114 8.79968 8.5032 9.0739 7.9858C9.34813 7.46839 9.74778 7.02806 10.2363 6.70513C10.7248 6.3822 11.2865 6.187 11.8699 6.1374C12.4534 6.08779 13.04 6.18538 13.576 6.42121C14.112 6.65705 14.5802 7.0236 14.9379 7.48729C15.2955 7.95097 15.5311 8.49698 15.623 9.0753C15.7149 9.65361 15.6603 10.2458 15.4641 10.7975C15.2679 11.3492 14.9364 11.8429 14.5 12.2333"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    </IconWrapper>
)
